import api from './api';

// --- Professor APIs ---

// Get all articles for Young India (Editorial Board access)
export const getAllArticles = async () => {
    try {
        const response = await api.get('/professor/articles');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Give a review to a student article
export const submitReview = async (articleId, reviewData) => {
    try {
        const response = await api.post(`/professor/articles/${articleId}/reviews`, reviewData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// Update a review rating
export const updateReviewRating = async (reviewId, rating) => {
    try {
        const response = await api.put(`/professor/reviews/${reviewId}/rating`, { rating });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Sub-EB APIs ---

// Get available users for Sub-EB selection
export const getAvailableSubEBUsers = async () => {
    try {
        const response = await api.get('/professor/sub-eb/available-users');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Request to make a user an Editorial Board member
export const requestSubEB = async (userId) => {
    try {
        const response = await api.post('/professor/sub-eb/request', { user_id: userId });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
